// contexts/SiteInfoContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { getSiteInfo } from "../firebase/services";

const SiteInfoContext = createContext();

export function SiteInfoProvider({ children }) {
  const [siteInfo, setSiteInfo] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSiteInfo() {
      try {
        setSiteInfo(await getSiteInfo());
      } catch (err) {}
      setLoading(false);
    }
    fetchSiteInfo();
  }, []);

  return (
    <SiteInfoContext.Provider value={{ siteInfo, loading }}>
      {children}
    </SiteInfoContext.Provider>
  );
}

export function useSiteInfo() {
  return useContext(SiteInfoContext);
}
